interface DemoUserJoinOptions {
  guestId: string;
  name: string;
  vocation: string;
  realm: string;
}

const DEMO_USERS: Record<string, DemoUserJoinOptions> = {
  'demo-alba': {
    guestId: 'demo-alba',
    name: 'Demo Alba',
    vocation: 'sleeper',
    realm: 'verdana',
  },
  'demo-briar': {
    guestId: 'demo-briar',
    name: 'Demo Briar',
    vocation: 'builder',
    realm: 'sablewind',
  },
  'demo-cinder': {
    guestId: 'demo-cinder',
    name: 'Demo Cinder',
    vocation: 'cook',
    realm: 'embermire',
  },
};

export function getDemoUserJoinOptions(search = window.location.search): DemoUserJoinOptions | null {
  const demoUser = new URLSearchParams(search).get('demoUser');
  if (!demoUser) return null;
  return DEMO_USERS[demoUser.toLowerCase()] ?? null;
}
